import React, { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { usePollAPI } from "../../hooks/usePollAPI";
import { IOrders } from "../../interfaces/IOrder";
import { IReduxAppState } from "../../reducers";
import APIExtensions from "../../yoello-lib/modules/API/APIDefs";
import { IMessageOptions } from "../../yoello-lib/modules/API/useAPI";
import useFormatCurrency from "../../yoello-lib/modules/localisation/useCurrency";
import { toLocalDate, toLocalTime } from "../../yoello-lib/modules/utils/TimeConversion";
import { IProcessedOrders } from "../orders/constants";

interface IOrderContext {
    openedOrders: IProcessedOrders[] | IOrders[];
    newOrders: IProcessedOrders[] | IOrders[];
    setMessageOptions: (doRefresh?: boolean) => void;
}

export const OrderContext = createContext<IOrderContext | undefined>(undefined);

export const useOrders = () => useContext(OrderContext);


export const OrdersContainer = ({ children }: { children: any }) => {

    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const [openMessage, setOpenMessage] = useState<IMessageOptions | null>(null);
    const [newMessage, setNewMessage] = useState<IMessageOptions | null>(null);
    const [refreshList, setRefreshList] = useState<boolean | undefined>(undefined);
    useEffect(() => {
        setMessageOptions();
        //eslint-disable-next-line
    }, [selectedVenueId]);
    function setMessageOptions(doRefresh?: boolean) {
        if (!selectedVenueId) return;
        if (doRefresh) { setRefreshList(doRefresh) }
        let newOrdersMessage;
        let openOrdersMessage;
        newOrdersMessage = `?order_status=PLACED&order_status=PAYMENT_PROCESSING&order_status=FUNDS_RECEIVED`;
        openOrdersMessage = `?order_status=ACCEPTED&order_status=READY_FOR_COLLECTION`;
        setOpenMessage(Object.assign({}, { preQuery: selectedVenueId, query: openOrdersMessage }));
        setNewMessage(Object.assign({}, { preQuery: selectedVenueId, query: newOrdersMessage }));
    }

    const props = {
        newMessage,
        openMessage,
        setMessageOptions,
        children,
        refreshList,
        setRefreshList
    }

    return <OrdersProvider {...props}>
        {children}
    </OrdersProvider>


}

function OrdersProvider({
    newMessage,
    openMessage,
    setMessageOptions,
    refreshList,
    setRefreshList,
    children }:
    {
        newMessage: IMessageOptions | null,
        openMessage: IMessageOptions | null,
        setMessageOptions: () => void,
        setRefreshList: (refreshList: boolean) => void,
        refreshList: boolean | undefined,
        children: any
    }) {
    const { formatCurrency } = useFormatCurrency();
    const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);
    const openedOrders = usePollAPI<IProcessedOrders>({ APIExtension: APIExtensions.orders, messageOptions: openMessage, disabled: isEposNow, triggerOnMount: false, refreshList: refreshList, setRefreshList: setRefreshList, dependencies: [{ disabled: isEposNow, messageOptions: openMessage }], transformFunction: (data: IOrders[]) => transformOrderList(formatCurrency, data) });
    const newOrders = usePollAPI<IProcessedOrders>({ APIExtension: APIExtensions.orders, messageOptions: newMessage, disabled: isEposNow, triggerOnMount: false, refreshList: refreshList, setRefreshList: setRefreshList, dependencies: [{ disabled: isEposNow, messageOptions: newMessage }], transformFunction: (data: IOrders[]) => transformOrderList(formatCurrency, data) });
    return <OrderContext.Provider value={{
        openedOrders,
        newOrders,
        setMessageOptions
    }}>
        {children}
    </OrderContext.Provider>
}


export function transformOrderList(formatCurrency: any, orderList: IOrders[]) {
    return orderList.map((order) => {
        const date = new Date(Date.parse(order.created_on));
        return {
            ...order,
            order_total: formatCurrency(order.order_total, true, order.currency_iso_code),
            created_on_time: toLocalTime(date),
            created_on_date: toLocalDate(date),
            elapsed: Date.now() - Date.parse(order.created_on)
        }
    });
}